import { TeamsSyncSettingsDTO } from '@vyce/core/src/api/types';
import { PaySchedule, Site } from '@vyce/core/src/types';

import { EnrichedTeamsSyncSettingsDTO } from '../types';

export const getTransformedData = (
  data: TeamsSyncSettingsDTO,
  paySchedules: PaySchedule[],
  sites: Site[]
): EnrichedTeamsSyncSettingsDTO => {
  return {
    active: data.active,
    isTimeSync: !!data.recent_time_periods,
    isPaySync: !!data.recent_pay_periods,
    recent_time_periods: data.recent_time_periods || 1,
    recent_pay_periods: data.recent_pay_periods || 1,
    pay_schedules: paySchedules.filter(schedule => data.pay_schedules?.includes(schedule.uuid ?? '')),
    time_sites: sites.filter(site => data.time_sites?.includes(site.uuid ?? '')),
  };
};
